import { render, staticRenderFns } from "./FAQView.vue?vue&type=template&id=b42c9b46&scoped=true&"
import script from "./FAQView.vue?vue&type=script&lang=js&"
export * from "./FAQView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b42c9b46",
  null
  
)

export default component.exports